import { render, staticRenderFns } from "./inspectionTaskDetailsList.vue?vue&type=template&id=72120b16&scoped=true"
import script from "./inspectionTaskDetailsList.vue?vue&type=script&lang=js"
export * from "./inspectionTaskDetailsList.vue?vue&type=script&lang=js"
import style0 from "./inspectionTaskDetailsList.vue?vue&type=style&index=0&id=72120b16&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72120b16",
  null
  
)

export default component.exports